<template>
  <div class="padding-sm">

    <router-link v-for="(item,index) in noticeList"
                 :key="index" :to="'/'+paths+'/noticeDetail?id='+item.msg_id"
                 :class="{'active':item.status === 0 }"
                 class="notice-item margin-bottom-sm flex align-center justify-between">
      <div class="notice-item-left">
        <h3>{{ item.msg_title }}</h3>
        <div class="desc" v-html="item.msg_content"></div>
      </div>
      <div class="notice-item-right margin-left">
        <el-button type="primary">查看详情</el-button>
      </div>
    </router-link>

    <div class="table-warpper">
      <el-pagination
          v-if="noticeList.length > 0"
          class="page-all"
          background
          @current-change="setPage"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>


    <div v-if="noData" class="flex align-center justify-around padding-xl">
      暂无数据
    </div>
  </div>
</template>

<script>
import {msgList} from "@/api/common";

export default {
  name: "notice",
  data() {
    return {
      noticeList: [],
      page: 1,
      total: 0,
      limit: 10,
      noData: false
    };
  },
  props: {
    paths: {
      type: String
    }
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await msgList(
          this.keyword,
          this.page,
          this.limit
      );
      this.noticeList = _list.data.list;
      this.total = _list.data.count;
      this.noticeList.length === 0 ? this.noData = true : this.noData = false
    },
    setPage() {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">
.notice-item {
  padding: 25px;
  border-radius: 10px;
  border: solid 1px #e2e2e2;
  overflow: hidden;
  position: relative;

  &:after {
    position: absolute;
    top: -5px;
    right: -35px;
    content: '已读';
    width: 100px;
    height: 40px;
    background: #999;
    color: #fff;
    transform: rotate(45deg);
    text-align: center;
    line-height: 50px;
  }

  &.active {
    &:after {
      position: absolute;
      top: -5px;
      right: -35px;
      content: '未读';
      width: 100px;
      height: 40px;
      background: #e84917;
      color: #fff;
      transform: rotate(45deg);
      text-align: center;
      line-height: 50px;
    }
  }

  .notice-item-left {
    flex: 1;
    overflow: hidden;

    h3 {
      font-size: 20px;
      line-height: 40px;
    }

    div {
      font-size: 16px;
      line-height: 30px;
      color: #999999;
      height: 60px;
      overflow: hidden;
    }
  }
}
</style>